export const CALLS_EXTRACT_ERROR = 'Ocorreu um erro ao buscar seu extrato de ligações'
export const CALLS_EXTRACT_DOWNLOAD_ERROR = 'Ocorreu um erro ao fazer download do seu extrato'